(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tchin-lendemain"] && !Shopify.designMode) return;
  try {
    
function initTchin(root){if(root.dataset.ready)return;root.dataset.ready='1';const slider=root.querySelector('[data-slider]');const thumbs=[...root.querySelectorAll('.tc-thumb')];const counter=root.querySelector('[data-current-slide]');let frame;const setSlide=index=>{thumbs.forEach((thumb,i)=>thumb.setAttribute('aria-pressed',String(i===index)));if(counter)counter.textContent=index+1;const active=thumbs[index];const rail=root.querySelector('.tc-thumbs');if(active&&rail)rail.scrollTo({left:active.offsetLeft-(rail.clientWidth-active.offsetWidth)/2,behavior:'smooth'});};if(slider){thumbs.forEach((button,index)=>button.addEventListener('click',()=>slider.scrollTo({left:index*slider.clientWidth,behavior:'smooth'})));slider.addEventListener('scroll',()=>{cancelAnimationFrame(frame);frame=requestAnimationFrame(()=>setSlide(Math.max(0,Math.min(thumbs.length-1,Math.round(slider.scrollLeft/slider.clientWidth)))));},{passive:true});slider.addEventListener('keydown',event=>{if(event.key!=='ArrowLeft'&&event.key!=='ArrowRight')return;event.preventDefault();const current=Math.round(slider.scrollLeft/slider.clientWidth);const next=Math.max(0,Math.min(thumbs.length-1,current+(event.key==='ArrowRight'?1:-1)));slider.scrollTo({left:next*slider.clientWidth,behavior:'smooth'});});}root.querySelectorAll('input[name="quantity"]').forEach(input=>input.addEventListener('change',()=>{root.querySelector('[data-total]').textContent=input.dataset.price;root.querySelector('[data-cta-label]').textContent=input.dataset.label;}));const form=root.querySelector('form[action*="/cart/add"]');if(form)form.addEventListener('submit',async event=>{if(!event.submitter||!event.submitter.matches('.tc-cta'))return;const drawer=document.querySelector('cart-drawer');if(!drawer)return;event.preventDefault();const button=event.submitter;if(button.getAttribute('aria-disabled')==='true')return;button.setAttribute('aria-disabled','true');button.disabled=true;try{const data=new FormData(form);data.append('sections',drawer.getSectionsToRender().map(section=>section.id));data.append('sections_url',window.location.pathname);drawer.setActiveElement(button);const response=await fetch(window.routes?.cart_add_url||'/cart/add.js',{method:'POST',headers:{Accept:'application/json','X-Requested-With':'XMLHttpRequest'},body:data});const state=await response.json();if(!response.ok||state.status)throw new Error(state.description||state.message||'Cart error');drawer.classList.remove('is-empty');drawer.renderContents(state);}catch(error){console.error(error);form.submit();}finally{button.removeAttribute('aria-disabled');button.disabled=false;}});}document.querySelectorAll('.tc').forEach(initTchin);document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('.tc').forEach(initTchin));
function initTchinStats(root){const section=root.querySelector('.tc-stats');if(!section||section.dataset.animated)return;section.dataset.animated='1';section.classList.add('is-pending');const numbers=[...section.querySelectorAll('[data-count]')];const reduced=window.matchMedia('(prefers-reduced-motion: reduce)').matches;const reveal=()=>{section.classList.add('is-visible');if(reduced)return;numbers.forEach((number,index)=>{const target=Number(number.dataset.count);number.textContent='0';const start=performance.now()+index*140;const duration=900;const tick=now=>{const progress=Math.max(0,Math.min(1,(now-start)/duration));const eased=1-Math.pow(1-progress,3);number.textContent=String(Math.round(target*eased));if(progress<1)requestAnimationFrame(tick);};requestAnimationFrame(tick);});};if(reduced||!('IntersectionObserver'in window)){reveal();return;}const observer=new IntersectionObserver(entries=>{if(!entries[0].isIntersecting)return;observer.disconnect();reveal();},{threshold:.28});observer.observe(section);}document.querySelectorAll('.tc').forEach(initTchinStats);document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('.tc').forEach(initTchinStats));
function initTchinCompare(root){const section=root.querySelector('.tc-compare');if(!section||section.dataset.dynamic)return;section.dataset.dynamic='1';section.classList.add('is-pending');const scroller=section.querySelector('.tc-compare-scroll');const progress=section.querySelector('.tc-compare-progress span');const updateProgress=()=>{if(!scroller||!progress)return;const max=scroller.scrollWidth-scroller.clientWidth;const ratio=max>0?scroller.scrollLeft/max:0;progress.style.width=`${26+ratio*74}%`;};if(scroller)scroller.addEventListener('scroll',updateProgress,{passive:true});updateProgress();const reveal=()=>section.classList.add('is-visible');if(!('IntersectionObserver'in window)||window.matchMedia('(prefers-reduced-motion: reduce)').matches){reveal();return;}const observer=new IntersectionObserver(entries=>{if(!entries[0].isIntersecting)return;observer.disconnect();reveal();},{threshold:.16});observer.observe(section);}document.querySelectorAll('.tc').forEach(initTchinCompare);document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('.tc').forEach(initTchinCompare));
function initTchinQuickFaq(root){const list=root.querySelector('.tc-quick-list');if(!list||list.dataset.ready)return;list.dataset.ready='1';list.querySelectorAll('details').forEach(item=>item.addEventListener('toggle',()=>{if(!item.open)return;list.querySelectorAll('details[open]').forEach(other=>{if(other!==item)other.open=false;});}));}document.querySelectorAll('.tc').forEach(initTchinQuickFaq);document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('.tc').forEach(initTchinQuickFaq));

  } catch(e) { console.error(e); }
})();
})();
